import { useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { Input, Label } from 'reactstrap';

import AdvancedSection from '../advanced-section';
import SectionCard from '../section-card';
import MicrosoftEntraFields from '../microsoft-connection';
import ConnectionStatus from '../microsoft-connection/components/ConnectionStatus';
import ImapHostFields from './components/ImapHostFields';
import IncomingPasswordFields from './components/IncomingPasswordFields';

const InboxSync = ({
    t,
    isFetching,
    defaultSettings,
    isMicrosoft,
    isCustom,
    imapSyncEnabled,
    onImapSyncChange,
    incomingSameAsSmtp,
    onIncomingSameAsSmtpChange,
    incomingSecretRequired,
    hasSavedIncomingSecret,
    forceAdvanced,
    redirectUri,
    onCopyRedirectUri,
    onOpenSetupGuide,
    isConnecting,
    isDisconnecting,
    onConnectClick,
    onReconnectClick,
    onDisconnectClick,
}) => {
    const [showAdvancedImap, setShowAdvancedImap] = useState(false);

    return (
        <SectionCard
            number={3}
            title={t('Inbox sync')}
            description={t('Sync incoming emails with the platform mailbox.')}
        >
            <div className="form-check form-switch" dir="ltr">
                <Input
                    type="checkbox"
                    className="form-check-input"
                    id="imapSyncEnabled"
                    checked={imapSyncEnabled}
                    onChange={(e) => onImapSyncChange(e.target.checked)}
                />
                <Label for="imapSyncEnabled" className="form-check-label fw-semibold">
                    {t('Enable inbox sync (IMAP)')}
                </Label>
                <div className="text-muted font-size-12">
                    {isMicrosoft
                        ? t('Syncs Inbox, Sent and Trash after you Connect Microsoft. Microsoft does not allow an IMAP password.')
                        : t('Syncs Inbox, Sent and Trash from this mailbox. First sync loads the last 100 messages per folder.')}
                </div>
            </div>

            {imapSyncEnabled && (
                <div className="border-top mt-3 pt-3">
                    {isMicrosoft ? (
                        <MicrosoftEntraFields
                            t={t}
                            isFetching={isFetching}
                            defaultSettings={defaultSettings}
                            oauthEntraConfigured={!!defaultSettings?.oauthEntraConfigured}
                            redirectUri={redirectUri}
                            onCopyRedirectUri={onCopyRedirectUri}
                            onOpenSetupGuide={onOpenSetupGuide}
                        />
                    ) : (
                        <IncomingPasswordFields
                            t={t}
                            isFetching={isFetching}
                            incomingSameAsSmtp={incomingSameAsSmtp}
                            incomingSecretRequired={incomingSecretRequired}
                            hasSavedIncomingSecret={hasSavedIncomingSecret}
                            onIncomingSameAsSmtpChange={onIncomingSameAsSmtpChange}
                        />
                    )}

                    <AdvancedSection
                        id="advanced-imap"
                        title={t('Advanced IMAP settings')}
                        info={t('Hosts are filled from the provider preset. Open Advanced only if IT asked you to override them.')}
                        isOpen={showAdvancedImap}
                        alwaysOpen={forceAdvanced}
                        onToggle={() => setShowAdvancedImap(!showAdvancedImap)}
                    >
                        <ImapHostFields
                            t={t}
                            isFetching={isFetching}
                            defaultSettings={defaultSettings}
                            required={isCustom}
                        />
                    </AdvancedSection>

                    {isMicrosoft && (
                        <div className="border-top mt-3 pt-3">
                            <ConnectionStatus
                                t={t}
                                oauthEntraConfigured={!!defaultSettings?.oauthEntraConfigured}
                                oauthConnected={!!defaultSettings?.oauthConnected}
                                mailboxAccountEmail={
                                    defaultSettings?.mailboxAccountEmail ||
                                    defaultSettings?.emailAddress
                                }
                                isConnecting={isConnecting}
                                isDisconnecting={isDisconnecting}
                                onConnectClick={onConnectClick}
                                onReconnectClick={onReconnectClick}
                                onDisconnectClick={onDisconnectClick}
                            />
                        </div>
                    )}
                </div>
            )}
        </SectionCard>
    );
};

export default withNamespaces()(InboxSync);
